import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect } from "react";
import { useState } from "react";
import { Grid, makeStyles, Typography, TextField, Button } from "@material-ui/core";
import { LinkAnimation, ListUserAttendance, MobileDialogCampusCalendarCheckoutAddCheckout, MobileDialogCampusCalendarCheckoutSelectTypeCheckout, MobileDialogCampusCalendarCheckinInjured, SwitchStatus, MobileContainerAnimation } from "../../../../../";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import AddLocationIcon from "@material-ui/icons/AddLocation";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import DoneIcon from "@material-ui/icons/Done";
import AddIcon from "@material-ui/icons/Add";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minHeight: "100%"
    },
    breadcrumb: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      position: "fixed",
      width: "100%",
      background: theme.palette.background["default"]
    },
    containerIcon: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "80px",
      marginTop: "60px",
      position: "fixed",
      width: "100%",
      background: theme.palette.background["default"]
    },
    textFlexWidth: {
      flexGrow: "1",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    content: {
      padding: "140px 8px 8px 8px",
      width: "100%"
    },
    textAnimation7s: {
      display: "inline-block",
      animation: "$animate 7s linear 2s alternate infinite"
    },
    mt12: {
      marginTop: "12px"
    },
    "@keyframes animate": {
      "0%": {
        transform: "translateX(0%)"
      },
      "25%": {
        transform: "translateX(0%)"
      },
      "75%": {
        transform: "translateX(-80%)"
      },
      "100%": {
        transform: "translateX(-80%)"
      }
    }
  };
});

var MobileCampusCalendarCheckOut = function MobileCampusCalendarCheckOut(props) {
  // console.log("MobileCampusCalendarCheckOut props", props);
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openDialogSelectTypeCheckOut = _useState2[0],
      setOpenDialogSelectTypeCheckOut = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialogAddCheckOut = _useState4[0],
      setOpenDialogAddCheckOut = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openDialogInjuredCheckOut = _useState6[0],
      setOpenDialogInjuredCheckOut = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      userSelected = _useState8[0],
      setUserSelected = _useState8[1];

  var _useState9 = useState(props.data ? props.data.comments || "" : ""),
      _useState10 = _slicedToArray(_useState9, 2),
      comments = _useState10[0],
      setComments = _useState10[1];

  useEffect(function () {
    setComments(props.data ? props.data.comments || "" : "");
  }, [props.data]);
  var classes = useStyles(); // HANDLE DIALOGS

  var handleDialogAddCheckOut = function handleDialogAddCheckOut() {
    if (openDialogAddCheckOut) {
      setUserSelected(null);
    }

    setOpenDialogAddCheckOut(!openDialogAddCheckOut);
  };

  var handleDialogSelectTypeCheckOut = function handleDialogSelectTypeCheckOut() {
    if (openDialogSelectTypeCheckOut) {
      setUserSelected(null);
    }

    setOpenDialogSelectTypeCheckOut(!openDialogSelectTypeCheckOut);
  };

  var handleDialogInjuredCheckOut = function handleDialogInjuredCheckOut() {
    if (openDialogInjuredCheckOut) {
      setUserSelected(null);
    }

    setOpenDialogInjuredCheckOut(!openDialogInjuredCheckOut);
  }; // HANDLE FUNCTIONS


  var handleClickUser = function handleClickUser(key) {
    var user = props.data ? props.data.attendance ? props.data.attendance.find(function (_user) {
      return _user.key === key;
    }) || null : null : null;

    if (user) {
      setUserSelected(user);

      if (user.status === "injured") {
        handleDialogInjuredCheckOut();
      } else {
        handleDialogSelectTypeCheckOut();
      }
    }
  }; // HANLDE SELECT TYPE CHECKOUT


  var handleSelectTypeCheckOut = function handleSelectTypeCheckOut(option) {
    if (option === "group_change") {
      setOpenDialogSelectTypeCheckOut(false);
      props.data.handleAddCheckOut(_objectSpread(_objectSpread({}, userSelected), {}, {
        status: "attended",
        checkout: {
          date: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
          responsible: {
            id: null,
            name: null
          },
          done: true,
          type: "group_change"
        }
      }));
    } else if (option === "exit") {
      setOpenDialogSelectTypeCheckOut(false);
      handleDialogAddCheckOut();
    }
  }; // --- HANDLE INJURED --- //
  // USER CONTINUES INJURED


  var handleInjuredSaysYes = function handleInjuredSaysYes() {
    props.data.handleAddCheckOut(_objectSpread(_objectSpread({}, userSelected), {}, {
      status: "not_attended"
    }));
    handleDialogInjuredCheckOut();
  }; // USER DISCONTINUES INJURED


  var handleInjuredSaysNo = function handleInjuredSaysNo() {
    setOpenDialogInjuredCheckOut(false);
    handleSelectTypeCheckOut();
  };

  var handleEditComments = function handleEditComments(e) {
    setComments(e.target.value);
  };

  var logicIcon = function logicIcon(classes, user) {
    if (user.status === "injured") {
      return /*#__PURE__*/React.createElement(AddIcon, {
        fontSize: "small",
        color: "secondary"
      });
    }

    if (user.checkout) {
      if (user.status === "attended") {
        return /*#__PURE__*/React.createElement(DoneAllIcon, {
          fontSize: "small",
          className: classes["icon_yes"]
        });
      } else {
        return /*#__PURE__*/React.createElement(DoneAllIcon, {
          fontSize: "small",
          className: classes["icon_no"]
        });
      }
    }

    if (user.status === "attended") {
      return /*#__PURE__*/React.createElement(DoneIcon, {
        fontSize: "small",
        className: classes["icon_yes"]
      });
    }

    if (user.status === "not_attended") {
      return /*#__PURE__*/React.createElement(DoneIcon, {
        fontSize: "small",
        className: classes["icon_no"]
      });
    }

    return /*#__PURE__*/React.createElement(DoneIcon, {
      fontSize: "small",
      className: classes["icon_maybe"]
    });
  };

  return /*#__PURE__*/React.createElement(MobileContainerAnimation, Object.assign({
    classses: classes.root
  }, props.routerState || null), /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumb
  }, /*#__PURE__*/React.createElement(LinkAnimation, props.link, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    fontSize: "large"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textFlexWidth
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.textAnimation7s
  }, props.data ? props.data.group ? props.data.group.name || "" : "" : ""))), /*#__PURE__*/React.createElement("div", {
    className: classes.containerIcon
  }, /*#__PURE__*/React.createElement(AddLocationIcon, {
    fontSize: "large",
    color: "primary"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.title ? props.translation.title || "Check out" : "Check out" : "Check out")), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    action_download: function action_download() {
      props.handleDownloadInfo();
      return null;
    },
    success: function success() {
      return /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(MobileDialogCampusCalendarCheckoutAddCheckout, {
        open: openDialogAddCheckOut,
        onClose: handleDialogAddCheckOut,
        data: userSelected,
        onSubmit: props.data.handleAddCheckOut,
        translation: props.translation
      }), /*#__PURE__*/React.createElement(MobileDialogCampusCalendarCheckoutSelectTypeCheckout, {
        open: openDialogSelectTypeCheckOut,
        onClose: handleDialogSelectTypeCheckOut,
        handleSelectOption: handleSelectTypeCheckOut,
        data: userSelected,
        translation: props.translation
      }), /*#__PURE__*/React.createElement(MobileDialogCampusCalendarCheckinInjured, {
        open: openDialogInjuredCheckOut,
        onClose: handleDialogInjuredCheckOut,
        handleYes: handleInjuredSaysYes,
        handleNo: handleInjuredSaysNo,
        translation: props.translation
      }), /*#__PURE__*/React.createElement(ListUserAttendance, {
        data: props.data ? props.data.attendance || [] : [],
        logicIcon: logicIcon,
        handleClickUser: handleClickUser
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(TextField, {
        className: classes.mt12,
        type: "text",
        multiline: true,
        rows: 4,
        value: comments,
        variant: "outlined",
        fullWidth: true,
        onChange: handleEditComments,
        placeholder: props.translation ? props.translation.comments : "Would you like to add some comments about today?"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.mt12
      }, props.data ? props.data.attendance.filter(function (user) {
        return user.checkout ? false : true;
      }).length > 0 ?
      /*#__PURE__*/
      // NOT FINISHED
      React.createElement(Button, {
        fullWidth: true,
        color: "primary",
        variant: props.data ? props.data.comments === comments ? "outlined" : "contained" : "outlined",
        disabled: props.data ? props.data.comments === comments ? true : false : true,
        onClick: function onClick() {
          props.data.handleSaveComments(comments);
        }
      }, props.data ? props.data.comments === comments ? props.translation ? props.translation.buttons ? props.translation.buttons.saved || "Saved" : "Saved" : "Saved" : props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save" : "") : // FINISHED
      props.data.attendance.filter(function (user) {
        return user.checkout ? false : true;
      }).length === 0 ? /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        color: "primary",
        variant: props.data ? props.data.comments === comments ? "contained" : "contained" : "outlined",
        disabled: props.data ? props.data.comments === comments ? false : false : true,
        onClick: function onClick(event) {
          props.data ? props.data.comments === comments ? props.data.handleFinish(comments) : props.data.handleSaveCommentsAndFinish(comments) : event.preventDefault();
        }
      }, props.data ? props.data.comments === comments ? props.translation ? props.translation.buttons ? props.translation.buttons.finish || "Finish" : "Finish" : "Finish" : props.translation ? props.translation.buttons ? props.translation.buttons.save_and_finish || "Save and finish" : "Save and finish" : "Save and finish" : "") : null : null));
    }
  })));
};

export { MobileCampusCalendarCheckOut };